import { COMPANY } from '@/mocks/home';

const QUICK_LINKS = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Request A Quote', href: '#quote' },
  { label: 'Jobs', href: '#jobs' },
  { label: 'Blog', href: '#news' },
  { label: 'Contact', href: '#contact' },
];

const SERVICE_LINKS = [
  { label: 'Janitorial Services', href: '#services' },
  { label: 'Office Cleaning', href: '#services' },
  { label: 'Medical Office Cleaning', href: '#services' },
  { label: 'Pressure Washing', href: '#services' },
  { label: 'Window Washing', href: '#services' },
  { label: 'Floor Care', href: '#services' },
];

const SOCIALS = [
  { icon: 'ri-facebook-fill', label: 'Facebook' },
  { icon: 'ri-twitter-x-fill', label: 'X' },
  { icon: 'ri-instagram-line', label: 'Instagram' },
  { icon: 'ri-youtube-fill', label: 'YouTube' },
  { icon: 'ri-google-fill', label: 'Google' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-800 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-background-50">
                <i className="ri-bubble-chart-fill text-2xl"></i>
              </span>
              <span className="leading-none">
                <span className="block font-heading text-xl font-extrabold text-background-50">
                  Crystal<span className="text-accent-400">Clean</span>
                </span>
                <span className="block text-[11px] font-medium uppercase tracking-[0.18em] text-secondary-200">
                  {COMPANY.slogan}
                </span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-secondary-200">
              For over 45 years, consistent, caring and compassionate commercial &amp; residential cleaning across
              Southwest Florida.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#home"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-700 text-background-50 transition-colors hover:bg-accent-500"
                >
                  <i className={`${s.icon} text-[16px]`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-400">
              Quick Links
            </h4>
            <ul className="mt-5 space-y-2.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-400">
              Our Services
            </h4>
            <ul className="mt-5 space-y-2.5">
              {SERVICE_LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-secondary-200 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-400">
              Get In Touch
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-secondary-200">
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-700 text-accent-400">
                  <i className="ri-map-pin-line text-[14px]"></i>
                </span>
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-700 text-accent-400">
                  <i className="ri-phone-line text-[14px]"></i>
                </span>
                <a href={COMPANY.phoneHref} className="hover:text-background-50">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-700 text-accent-400">
                  <i className="ri-mail-line text-[14px]"></i>
                </span>
                <a href={`mailto:${COMPANY.email}`} className="break-all hover:text-background-50">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-secondary-300 sm:flex-row md:px-6">
          <p>
            © {COMPANY.since}–2026 {COMPANY.name}. All Rights Reserved. Licensed &amp; Insured · FL #S11588
          </p>
          <div className="flex items-center gap-4">
            <a href="#jobs" className="hover:text-background-50">
              Accessibility Statement
            </a>
            <a href="#about" className="hover:text-background-50">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}